import type { AppErrorEvent } from "@optimyl/events";
import { isRedirecting } from "../auth/identityRedirect";
import { useFormStore } from "../store/formStore";
import { useUiStore } from "../store/uiStore";
import { ApiError } from "../types";
import { trackError } from "./appInsights";

/**
 * What the app does with a published error: App Insights, and a toast. A 401 is neither: the sign-in it starts is the
 * answer, and a caller that republishes one (the lock heartbeat) would otherwise show it twice. While the tab is leaving
 * for a sign-in or a sign-out, an error is still tracked but not shown: nobody will see it, and a toast would flash as
 * the page goes.
 */
export function reportError(event: AppErrorEvent): void {
  if (event.error instanceof ApiError && event.error.status === 401) return;

  const formState = useFormStore.getState();
  trackError(event.error, {
    ...event.properties,
    context: event.context ?? "unknown",
    currentStep: String(formState.currentStep),
    formId: formState.formId ?? "none",
    formStatus: formState.formStatus,
  });
  if (!isRedirecting()) {
    useUiStore.getState().addToast(event.error.message, "error");
  }
}
